import {
  Component,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { timer } from 'rxjs';
import {
  takeUntil,
  timeout
} from 'rxjs/operators';
import { ChartsService } from '../../charts.service';
import { ZingChartComponent } from '../base-classes/zing-chart';
import { ColorThemeService } from '../../../common/services/color-theme.service';
import { ThemeColor } from '../../../common/enums/theme-color.enum';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-ivx-chart',
  templateUrl: './ivx-chart.component.html',
  styleUrls: ['./ivx-chart.component.scss']
})
export class IvxChartComponent extends ZingChartComponent implements OnInit {
  public isChartHasData = true;
  public isChartLoading = true;
  private values = [];
  private dates: any[] = [];
  private maxValue = 0;
  private minValue = 0;

  constructor(
    private chartService: ChartsService,
    protected colorThemeService: ColorThemeService,
    @Inject(AppStore) protected readonly store: Redux.Store<AppState>,

    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super(
      colorThemeService,
      store,
      paymentWindowService
    );
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  protected getChartData() {
    if (!this.instrument) return;

    this.dates = [];

    this.chartService
      .getIVXChartData(this.instrument)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data && data.length > 0) {
          this.isChartHasData = true;
          this.values = [];
          data.forEach(row => {
            this.dates.push(row.time.substring(11, 16));
            this.values.push(Math.round(row.value * 100 * 100) / 100);
          }, this);

          this.maxValue = (Math.ceil(Math.max.apply(Math, this.values) * 10) / 10) + 0.1;
          const minP = (Math.floor(Math.min.apply(Math, this.values) * 10) / 10);
          this.minValue = (minP === 0) ? 0 : (minP - 0.1);
          setTimeout(() => this.renderChart())
          this.isChartLoading = false;
        } else {
          this.isChartHasData = false;
          this.isChartLoading = false;
        }
      });
  }

   governmentRequests = [3, 3, 4, 6, 4, 3, 3, 11, 12, 14, 15, 20];

  protected get getChartConfig(): Object {
    return {
      'type': 'area',
      'background-color': this.theme === ThemeColor.DARK ? '#242525' : '#fff',
      'utc': true,
      'plotarea': {
        'margin': '15px 25px 50px 85px',
        'background-color': this.backgroundColor
      },
      'scale-x': {
        'values': this.dates,
        'shadow': 0,
        'line-color': this.lineColor,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor
        },
        'item': {
          'font-color': this.lineColor,
          'font-size': '10px',
          'font-angle': -90
        },
        'label': {
          'text': '',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0
      },
      'scale-y': {
        'values': this.minValue + ':' + this.maxValue + ':0.1',
        'format': '%v %',
        'line-color': this.lineColor,
        'shadow': 0,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor,
          'line-style': 'dashed'
        },
        'item': {
          'font-color': this.lineColor
        },
        'label': {
          'text': 'IVX 30 day',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0,
        'thousands-separator': ','
      },
      'crosshair-x': {
        'line-color': this.lineColor,
        'plot-label': {
          'border-radius': '3px',
          'border-width': '1px',
          'border-color': this.lineColor,
          'padding': '10px',
          'font-weight': 'bold'
        },
        'scale-label': {
          'font-color': '#00baf0',
          'background-color': this.backgroundColor,
          'border-radius': '3px'
        }
      },
      'tooltip': {
        'visible': false
      },
      'plot': {
        'tooltip-text': '%t views: %v<br>%k',
        'shadow': 0,
        'line-width': '3px',
        'marker': {
          'type': 'circle',
          'size': 1
        },
        'hover-marker': {
          'type': 'circle',
          'size': 2,
          'border-width': '1px'
        }
      },
      'series': [
        {
          'values': this.values,
          'text': 'IVX 30',
          'line-color': '#00AD80',
          'background-color': '#ffffff #00AD80',
          'marker': {
            'background-color': '#00AD80',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#00e8ac'
          }
        },
        {
          'values': this.governmentRequests,
          'text': 'IVX 30 2',
          'line-color': '#ad0000',
          'background-color': '#ffffff #00AD80',
          'marker': {
            'background-color': '#ad0000',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#e80000'
          }
        }
      ]
    };
  }
}
